// REACT
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

// MATERIAL UI
import { Tabs, Tab } from "@mui/material";

// STYLES
import { PageWithHeaderStyles } from "./PageWithHeaders.styles";

// AMPLITUDE
import { trackEvent } from "src/Amplitude";

interface PagesWithHeadersProps {
  components: { title: string; component: JSX.Element; path: string }[] | undefined;
  default?: JSX.Element;
}

const PagesWithHeaders = ({ components }: PagesWithHeadersProps) => {
  const classes = PageWithHeaderStyles();

  // STATE
  const [activeComponent, setActiveComponent] = useState<JSX.Element | null>(null);

  // HOOKS
  const location = useLocation();

  // Set Active component onload
  useEffect(() => {
    components?.forEach((entry) => {
      if (entry.path === location.pathname) setActiveComponent(entry.component);
      return;
    });
  }, [components]);

  return (
    <>
      <Tabs
        indicatorColor="secondary"
        className={classes.tabsContainer}
        classes={{ indicator: classes.activeTab }}
        value={location.pathname}>
        {components?.map((route: any, key: number) => (
          <Tab
            onClick={() => trackEvent(`Changed_Settings_Tab`, { route: route.title }, "Settings")}
            key={key}
            component={NavLink}
            to={route.path}
            label={route.title}
            value={route.path}
            className={`${classes.tab} ${
              location.pathname === route.path ? classes.activeTab : ""
            }`}
          />
        ))}
      </Tabs>
      {activeComponent}
    </>
  );
};

export default PagesWithHeaders;
